import type { MarlinStore } from "@observe-tech/marlin-store/core";
import { subscribeToIpJsonEdits } from "./ipJsonBridge";

const feedUpdater = (store: MarlinStore): (() => void) => {
  const updater = store.capabilities.updater;
  if (!updater) return () => undefined;

  void store.settings
    .getDatarouterConfig()
    .then((config) => updater.applyDatarouterConfig(config))
    .catch((error) =>
      console.warn("[shell] applying the datarouter config failed", error),
    );

  const subscription = store
    .observe(async () => ({
      settings: await store.settings.getAutoUpdateSettings(),
      sites: await store.sites.getMachines(),
    }))
    .subscribe({
      next: ({ settings, sites }) =>
        void updater
          .pushAutoUpdateInputs({ enabled: settings.enabled, sites })
          .catch((error) =>
            console.warn("[shell] pushing auto-update inputs failed", error),
          ),
      error: (error: unknown) =>
        console.error("[shell] auto-update inputs query failed", error),
    });
  return () => subscription.unsubscribe();
};

export const startHostBridges = (store: MarlinStore): (() => void) => {
  const stopUpdater = feedUpdater(store);
  const stopIpJson = subscribeToIpJsonEdits(store);
  return () => {
    stopUpdater();
    stopIpJson();
  };
};
